import CONSTANT from '../../constant/cookie'
import COMMON_CONSTANT from '../../constant/common'
import cookie from '../../lib/cookie'
export default {
    data(){
        return{
            isInQYGChannel: false,
            qygHomeHref: ''

        }
    },
    mounted() {

        if(cookie(CONSTANT.COOKIE_CO) === CONSTANT.COOKIE_CO_IS_QYG){
            this.isInQYGChannel = true
            this.qygHomeHref = '/global/' + COMMON_CONSTANT.COMMON_QYG_CATEGORY_ID
        }
    }
}
